
export function batchesProcessing(prefix: string) {
    // Batches Management Routes
    const BATCHES_MANAGEMENT = `${prefix}/batches-management/`;
    
    // Daily Processing Sub-Menu Routes
    const DAILY_PROCESSING = `${BATCHES_MANAGEMENT}/daily-processing/`;
        
    const DAILY_PROCESSING_MENU = {
        ROOT: DAILY_PROCESSING,
        
        UPDATE: `${DAILY_PROCESSING}update`,
        
        DEPENDENCIES: `${DAILY_PROCESSING}dependencies`,
        
        FINANCIAL_INSTITUTES_TABLE: `${DAILY_PROCESSING}financial-institutes-table`,
        
        SUPERVISION: `${DAILY_PROCESSING}supervision`,
        
        TRACES: `${DAILY_PROCESSING}traces`,
        
        ERRORS: `${DAILY_PROCESSING}errors`,

    };

    const BATCHES_MANAGEMENT_MENU = {
        ROOT: BATCHES_MANAGEMENT,
        BATCHES_PARAMETERS: `${BATCHES_MANAGEMENT}batches-parameters`,
        BATCHES_DEPENDENCIES: `${BATCHES_MANAGEMENT}batches-dependencies`,
        BATCHES_MONITORING: `${BATCHES_MANAGEMENT}batches-monitoring`,
        BATCHES_MAINTENANCE: `${BATCHES_MANAGEMENT}batches-maintenance`,
        BATCH_ERRORS: `${BATCHES_MANAGEMENT}batch-errors`,
        BATCHES_TRACKS: `${BATCHES_MANAGEMENT}batches-tracks`,
        DAILY_PROCESSING_MENU
    };

    return {
        ROOT: prefix,
        BATCHES_MANAGEMENT_MENU,       
    }
}